import { createBrowserRouter } from "react-router-dom";

import Register from "../pages/register";
import ChatPage from "../pages/ChatPage";
import AdminPage from "../pages/AdminPage";  // ← add this

const router = createBrowserRouter([
  { path: "/register", element: <Register /> },
  { path: "/",         element: <ChatPage /> },
  { path: "/admin",    element: <AdminPage /> },  // ← add this
]);

export default router;